import React from "react";

interface PillProps {
  children: React.ReactNode;
  variant?: "warning" | "completed" | "info" | "default" | "error" | "primary";
  noMargin?: boolean;
}

// This is known as the Elements->Badge component in Figma.
const Pill = ({ children, variant = "completed", noMargin = false }: PillProps) => {
  const variantStyles = {
    warning: "bg-amber-100 text-amber-800",
    completed: "bg-emerald-100 text-emerald-800",
    info: "bg-blue-100 text-blue-800",
    default: "bg-[#F5F4F9] text-[#332E42]",
    error: "bg-red-100 text-red-800",
    primary: "bg-primary-100 text-primary-700",
  };

  return (
    <span
      className={`
      inline-block px-2.5 py-0.5 rounded-[10px]
      text-xs font-medium leading-4 ${noMargin ? "" : "ml-2"}
      ${variantStyles[variant]}
    `}
    >
      {children}
    </span>
  );
};

export default Pill;
